import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM, {
    unstable_renderSubtreeIntoContainer as renderSubtreeIntoContainer,
} from 'react-dom';
import Popper from 'popper.js';
import { getComponentClasses } from '@99designs/utils/app';
import isEqual from 'lodash.isequal';

export default class Card extends React.Component {
    constructor(props) {
        super(props);

        this.popper = null;

        this.card = null;
        this.arrow = null;

        this.state = {
            popperStyle: {},
            popperAttributes: {},
            arrowStyle: {},
        };

        this.applyReactStyle = this.applyReactStyle.bind(this);
        this.update = this.update.bind(this);
    }

    componentDidMount() {
        const options = {
            placement: this.props.placement || 'bottom',
            modifiers: {
                offset: {
                    offset: '10,10',
                },
                flip: this.props.placement // Turn off automatic placement features when a placement is manually set
                    ? {}
                    : { behavior: ['bottom', 'top', 'left', 'right'] },
                preventOverflow: this.props.placement // Turn off automatic placement features when a placement is manually set
                    ? undefined
                    : { boundariesElement: 'viewport', padding: 10 },
                arrow: {
                    element: this.arrow,
                },
                applyStyle: { enabled: false },
                applyReactStyle: {
                    enabled: true,
                    fn: this.applyReactStyle,
                    order: 900,
                },
            },
        };

        this.popper = new Popper(this.props.target, this.card, options);

        window.addEventListener('promo-bar-show', this.update);
        window.addEventListener('promo-bar-hide', this.update);
    }

    shouldComponentUpdate(props, state) {
        return !isEqual(this.props, props) || !isEqual(this.state, state);
    }

    componentDidUpdate() {
        this.popper.update();
    }

    componentWillUnmount() {
        this.popper.destroy();
        this.popper = null;

        window.removeEventListener('promo-bar-show', this.update);
        window.removeEventListener('promo-bar-hide', this.update);
    }

    update() {
        if (this.popper) {
            this.popper.update();
        }
    }

    applyReactStyle(data, options) {
        const attributes = {
            'data-placement': data.placement || 'bottom',
            'data-out-of-boundaries': data.hide || undefined,
        };

        this.setState({
            popperStyle: data.styles,
            popperAttributes: attributes,
            arrowStyle: data.offsets.arrow,
        });
    }

    render() {
        const classes = getComponentClasses('popover-card', this.props.variations);
        return (
            <div
                className={classes}
                ref={card => (this.card = card)}
                style={this.state.popperStyle}
                {...this.state.popperAttributes}
            >
                <div
                    className="popover-card__arrow"
                    style={this.state.arrowStyle}
                    ref={arrow => (this.arrow = arrow)}
                />
                <div className="popover-card__content">
                    <div className="popover-card__content__inner">{this.props.children}</div>
                </div>
            </div>
        );
    }
}
Card.propTypes = {
    children: PropTypes.node,
    variations: PropTypes.array,
    placement: PropTypes.string,
    target: PropTypes.instanceOf(window.Element).isRequired, // DOM Element
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/PopoverCard/Card.jsx